import { useState } from "react";
import { createPortal } from "react-dom";
import { useTranslation } from "react-i18next";
import VibratingButton from "@/components/base/button/VibratingButton.tsx";
import IconQrCode from "@/assets/icons/qr-code.svg?react";
import showCustomToast from "@/shared/utils/showCustomToast.ts";
import LoyaltyScanScreen from "./LoyaltyScanScreen.tsx";

/** Single floating QR action. Tapping it opens the full-screen scan
 *  experience (live camera) with a swipe-up sheet that reveals the user's
 *  own QR code. */
export default function LoyaltyQRButton() {
  const { t } = useTranslation();
  const [scanOpen, setScanOpen] = useState(false);

  // Handle a decoded QR from the in-app scanner. TODO: wire the payload to
  // the loyalty scan backend flow once defined — for now a toast + close.
  const handleScannedResult = (text: string) => {
    if (!text) return;
    showCustomToast(text, "success");
    setScanOpen(false);
  };

  return (
    <>
      {/* Floating QR button — portalled to document.body so it lives OUTSIDE
          the [data-vaul-drawer-wrapper]; without the portal vaul's
          background-scale transform would drag this fixed button along. */}
      {createPortal(
        <VibratingButton
          onClick={() => setScanOpen(true)}
          className="fixed right-4 z-20 size-14 flex-center bg-dark/40 backdrop-blur-md border border-orange-100/80 text-orange-100 rounded-full shadow-[0_8px_24px_rgba(251,199,108,0.3)] transition-200 active:bg-orange-100/10"
          style={{ bottom: "calc(1.25rem + env(safe-area-inset-bottom))" }}
          vibrationType="light"
          aria-label={t("show_qr")}
        >
          <IconQrCode className="size-6 text-orange-100" />
        </VibratingButton>,
        document.body
      )}

      <LoyaltyScanScreen
        isOpen={scanOpen}
        onClose={() => setScanOpen(false)}
        onScanned={handleScannedResult}
      />
    </>
  );
}
